module.exports = __webpack_public_path__ + "static/Mega-Walk-In-Drive-Popup-Image-8720fd784e39ce8d8ccd2ffcdf1d417f.png";